// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/d5099da4/" + chunkId + "." + __webpack_require__.h() + ".vd5099da4.js";
};